import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

import CustomInput from "../../UI/PageInput/CustomInput";
import CenteredHeading from "../../UI/headingsUI/CenteredHeading";
import GrayButton from "../../UI/buttonUI/GrayButton";
import CustomDescriptionInput from "../../UI/PageInput/CustomDescriptionInput";
import ExpenseViewDialog from "../../UI/viewDialogs/expense/ExpenseViewDialog";
import PrimaryButton from "../../UI/buttonUI/PrimaryButton";
import { CirclePlus } from "lucide-react";
import { positiveNumberValidation } from "../../../validations/formValidations";

const AddLoan = ({ sendData, loading, successResponse }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const { name, id, loanBalance } = useParams();

  const onSubmit = (data) => {
    const formData = {
      receiver_id: id,
      user_id: 1,
      category_id: 4,
      ...data,
    };
    sendData(formData, reset);
  };
  return (
    <div className="form-container">
      <CenteredHeading title="Add Loan" />
      <div className="formDetails">
        <p>
          <strong>User Name</strong> : {name}
        </p>
        <p>
          <strong>User Id</strong> : {id}
        </p>
        <p>
          <strong>Current Loan</strong> : ₹{loanBalance}
        </p>
      </div>
      <form
        className="form-border max-w-5xl mx-auto"
        onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
      >
        <CustomInput
          type="number"
          name="amount"
          labelText="Amount *"
          placeholder="Enter"
          register={{
            ...register("amount", {
              ...positiveNumberValidation,
              required: "Please Enter an amount",
            }),
          }}
          error={errors.amount}
        />
        <CustomDescriptionInput
          name="description"
          labelText="Description *"
          register={{
            ...register("description", {
              required: "Please Enter Description",
            }),
          }}
          error={errors.description}
        />
        <div className="addLoanBtnWrap">
          <p className="addWrap">
            <PrimaryButton
              btnText={!loading ? "Add Loan" : "Adding..."}
              loading={loading}
              Icon={CirclePlus}
              size={18}
            />
          </p>
          <p className="grayWrap">
            <GrayButton btnText="Cancel" width="w-40" onClick={() => reset()} />
          </p>
        </div>
      </form>
      {successResponse && (
        <ExpenseViewDialog
          viewDetails={successResponse}
          successMsg="Loan Successfully Created!"
        />
      )}
    </div>
  );
};
export default AddLoan;
